module.exports = __webpack_public_path__ + "media/images/icons/download-f0c6237564faf3fb040013f0b17aed66.svg";